module.exports = __webpack_public_path__ + "static/media/CHAP02-PHOTO-SKIRMISH.138d7890.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StaticElement/img/CHAP02-PHOTO-SKIRMISH.png
// module id = 282
// module chunks = 0